import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/SignOut.es.js";
const t = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(n, { ref: r, ...e, weights: a }));
t.displayName = "SignOutIcon";
const c = t;
export {
  c as SignOut,
  t as SignOutIcon
};
